export { NewsCard } from "./NewsCard";
